import TextField from '@mui/material/TextField';
import InputAdornment from '@mui/material/InputAdornment';
import Image from "next/image";

export default function SearchBox({
  value,
  onChange,
  placeholder,
  locale = "ar",
  sx = {},
  inputProps = {},
  ...rest
}) {
  return (
    <TextField
      value={value}
      onChange={onChange}
      placeholder={placeholder}
      sx={{
        width: { xs: 300, md: 500 },
        mx: 1,
        mt: { xs: 3, md: 1 },
        textAlign: "right",
        borderRadius: 5,
        bgcolor: "white",
        "& .MuiOutlinedInput-root": {
          borderRadius: "8px",
          "& fieldset": {
            borderColor: "lightgrey",
          },
          "&:hover fieldset": {
            borderColor: "lightgrey",
          },
          "&.Mui-focused fieldset": {
            borderColor: "lightgrey",
          },
          paddingRight: locale === "ar" ? "8px !important" : "10px !important",
        },
        ...sx,
      }}
      InputProps={{
        endAdornment: (
          <InputAdornment
            position="end"
            sx={{
              bgcolor: "#0C3F82",
              borderRadius: "8px",
              p: "8px 12px",
              width: "44px",
              height: "40px",
            }}
          >
            <Image
              src="https://contact-app-prod.s3.us-east-2.amazonaws.com/contact.eg/search-icon.svg"
              alt="Search Icon"
              loading="lazy"
              width={19}
              height={19}
              style={{
                filter: "brightness(0) saturate(100%) invert(100%)",
              }}
            />
          </InputAdornment>
        ),
        ...inputProps,
      }}
      {...rest}
    />
  );
}
